import * as z from "zod";
import { userFacingError } from "../authorization";
import { USER_GROUPS_NAME_UNIQUE } from "../dbConstraints";
import { isUniqueConstraintViolation } from "../dbErrors";
import { assertIdpSyncNotActive } from "../rbac/validation";
import { userGroupNameField } from "./createUserGroup";
import { mutator } from "./mutator";

export const updateUserGroup = mutator({
  schema: z.object({
    userGroupId: z.string(),
    name: userGroupNameField.optional(),
  }),
  resolve: {
    userGroup: { kind: "userGroup", from: "userGroupId" },
  },
  permissions: [
    {
      permission: "user_group:write",
      scopeId: ({ args }) => args.userGroup.id,
    },
  ],
  fn: async ({ tx, ctx, args: { userGroup, name } }) => {
    // Renaming is gated by groupMembership, not groupLifecycle: when the IdP
    // syncs membership it matches the claim against the group's name, so the
    // name is the sync key and must be locked under "jit_users_and_groups" (and
    // SCIM), while creating and deleting groups stay available there.
    await assertIdpSyncNotActive(tx, ctx.tenantId, "groupMembership");
    if (name !== undefined) {
      try {
        await tx.mutate.userGroups.update({
          id: userGroup.id,
          name,
          updatedAt: Date.now(),
        });
      } catch (err) {
        if (isUniqueConstraintViolation(err, USER_GROUPS_NAME_UNIQUE)) {
          throw userFacingError("A group with this name already exists");
        }
        throw err;
      }
    }
  },
});
